import * as React from 'react';
import type { Editor } from '@tiptap/react';

import { useTiptapEditor } from '../../../../app/rte/hooks/use-tiptap-editor';

export interface UseTableControlsConfig {
  editor?: Editor | null;
}

function isInsideTable(editor: Editor | null): boolean {
  if (!editor || !editor.isEditable) {
    return false;
  }
  return editor.isActive('table');
}

export function useTableControls(config?: UseTableControlsConfig) {
  const { editor } = useTiptapEditor(config?.editor);
  const [isVisible, setIsVisible] = React.useState<boolean>(() =>
    isInsideTable(editor)
  );

  React.useEffect(() => {
    if (!editor) {
      return;
    }
    const update = () => setIsVisible(isInsideTable(editor));
    update();
    editor.on('selectionUpdate', update);
    return () => {
      editor.off('selectionUpdate', update);
    };
  }, [editor]);

  return { editor, isVisible };
}
